module.exports = __webpack_public_path__ + "img/gema.df6985c4.png";